import {
  Stack,
  StratusClient
} from '@jarvis/web-stratus-client/dist/src/clients/stratus-client';

import type { SubscriptionOptionsResponse } from '../types/subscription';
import type { JarvisAuthProvider } from '@jarvis/web-http';
import getEnvironmentVariables from 'src/helpers/getEnvironmentVariables';
import { getStack } from 'src/helpers/getStack';

export class SubscriptionsOptionsClient extends StratusClient {
  apiName = 'ws-hp.com/subscriptions';
  apiVersion = '1';
  timeout = 0;
  stack: Stack; // Declare stack property
  blId = '';

  constructor(authProvider: JarvisAuthProvider, stack: Stack, blId: string) {
    const env = getEnvironmentVariables(getStack(stack));
    super(env?.variables?.SUBSCRIPTION_BASE_URL, authProvider);
    this.stack = stack;
    this.blId = blId;
  }

  async getSubscriptionOptions(
    subscriptionId: string,
    entityId?: string
  ): Promise<SubscriptionOptionsResponse> {
    const env = getEnvironmentVariables(getStack(this.stack));
    const baseUrl = env.variables.SUBSCRIPTION_BASE_URL;
    let url = `${baseUrl}/${this.blId}/subscriptions/${subscriptionId}/options`;
    if (entityId) {
      url += `?entityIds=${entityId}`;
    }
    return this.jarvisWebHttpInstance
      .get({
        url: url,
        timeout: this.timeout
      })
      .then((response) => response.data);
  }
}
